import { render } from "./carousel-holder.vue?vue&type=template&id=96eaf188"
import script from "./carousel-holder.vue?vue&type=script&lang=js"
export * from "./carousel-holder.vue?vue&type=script&lang=js"

import "./carousel-holder.vue?vue&type=style&index=0&id=96eaf188&lang=css"

import exportComponent from "/Users/drewcarrette/Sites/trauma/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__